import { createFileRoute } from "@tanstack/react-router";
import { getIspmHostConfig } from "../../config/ispmHostConfig";
import { MfeLoader } from "../../mfe/MfeLoader";
import { usePermissionState } from "../../contexts/PermissionStateContext";

export const Route = createFileRoute("/identities/")({
  component: IspmIdentitiesPage,
});

function IspmIdentitiesPage() {
  const permissionState = usePermissionState();
  return (
    <MfeLoader
      name="ispm-ui"
      props={{ hostConfig: getIspmHostConfig(undefined, permissionState) }}
    />
  );
}
